export { Effect, mergeEffects } from './src/effects';
export { Actions } from './src/actions';
export { EffectsModule } from './src/effects.module';
export { EffectsSubscription } from './src/effects-subscription';
export { toPayload } from './src/util';
export { runAfterBootstrapEffects } from './src/bootstrap-listener';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/@ngrx/effects/index.js
// module id = ../../../../@ngrx/effects/index.js
// module chunks = 7